import { render, staticRenderFns } from "./ProfileFilled.vue?vue&type=template&id=48f63f4a"
import script from "./ProfileFilled.vue?vue&type=script&lang=js"
export * from "./ProfileFilled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports